import { Component, Input } from '@angular/core';
import { IAvailableUnitValues, IProductionUnitValues } from '@brafton/atlas-api-client';

@Component({
  selector: 'shared-calendar-units-header',
  templateUrl: './calendar-units-header.component.html',
  styleUrls: ['./calendar-units-header.component.scss'],
  host: { class: 'calendar-units-header' },
})
export class SharedCalendarUnitsHeaderComponent {
  @Input() numberFormat = '1.0-1';
  @Input() units?: IProductionUnitValues | IAvailableUnitValues;

  constructor(
  ) { }


}
